<template>
  <b-table :items="certificados"
           :fields="fields"
           responsive
           hover
           @row-clicked="onSelectCertificado" />
</template>

<script>
  export default {
    props: [ 'certificados' ],
    data () {
      return {
        fields: [{
          key: 'certificadoUsuario',
          sortable: true,
          label: 'Nome'
        }, {
          key: 'dataVencimento',
          sortable: true,
          label: 'Validade'
        }, {
          key: 'cpf',
          sortable: true,
          label: 'CPF'
        }]
      }
    },
    methods: {
      onSelectCertificado (item) {
        this.$emit('onSelectCertificado', item)
      }
    }
  }
</script>
